/* unplugin-vue-components disabled */import { render } from "./StudentScheduleDialog.vue?vue&type=template&id=28b264ad&scoped=true"
import script from "./StudentScheduleDialog.vue?vue&type=script&lang=js"
export * from "./StudentScheduleDialog.vue?vue&type=script&lang=js"

import "./StudentScheduleDialog.vue?vue&type=style&index=0&id=28b264ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b264ad"]])

export default __exports__